/**
 * Channel Detail Save Defaults Policy
 * 
 * Triggered when default values save is initiated.
 * Calls backend API to update channel default publication values.
 */

import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { ChannelsState } from '../state';
import { ChannelsCommand } from '../commands';

export const createChannelDetailSaveDefaultsPolicy = (
  backend: ClientLibraryType
): Policy<ChannelsState, ChannelsCommand> => ({
  name: 'channel-detail-save-defaults',

  shouldReact: ( prev, next ) => {
    // Trigger when savingDefaults changes from false to true
    return !prev.channelDetail.loading.savingDefaults && next.channelDetail.loading.savingDefaults;
  },

  onStateChange: async ({ next, ctx }) => {
    const { dispatch } = ctx;
    
    if ( next.channelDetail.mode.type !== 'view' ) return;
    
const integrationId = next.channelDetail.mode.integrationId;
   const channel = next.salesChannels[integrationId];
    const defaultValuesData = next.channelDetail.defaultValues.data;
    
    if ( !channel ) return;

    // eslint-disable-next-line teselly/no-swallowed-command-dispatch -- console.error operator log only + documented TODO to add an error notification; no user surface yet (TV1-2010 waiver, not a rethrow).
    try {
      await backend.commands.UpdateSystemIntegrationConfiguration({
        id: channel.id,
        body: {
          id: channel.id,
          accountId: channel.accountId,
          connectorId: channel.connectorId,
          integrationUserId: channel.integrationUserId,
          defaultPublicationValues: defaultValuesData
        }
      });
      
      // Success - update original data and show success feedback
      dispatch(
        { type: 'integrations/channels/detail/defaultValues/saveSuccess', payload: {}},
        { source: 'policy' }
      );
      
      // Clear success message after 2 seconds
      setTimeout(() => {
        dispatch(
          { type: 'integrations/channels/detail/defaultValues/clearSuccess', payload: {}},
          { source: 'policy' }
        );
      }, 2000 );
    } catch ( error ) {
      console.error( 'Error saving default values:', error );
      // TODO: Show error notification
    } finally {
      dispatch(
        { type: 'integrations/channels/detail/loading/setSavingDefaults', payload: { isLoading: false }},
        { source: 'policy' }
      );
    }
  }
});
